export default __webpack_public_path__ + "static/media/gallery02.b0875437.jpg";